import React from 'react';
import { Button, Header, Segment, Tab, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';
// import { Random } from 'react-animated-text';
import { fetchMarks, fetchStudyType } from '../../Lookups/util';
import StudentsWithoutGradesCommitteeExam from './StudentsWithoutGradesCommitteeExam';
import StudentsWithoutGrades from './InputGrades';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export const fetchStudyPograms = (courseImplementationId) => axios.get(`professor/study-programs-by-course/${courseImplementationId}`);


export default class GradingCommitteeExam extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            marks: [],
            studyTypes: [],
            studyPrograms: [],
            course: '',

            loaded: false,
            graded: false,
            finalizeCheck: false,
            finishGrading: false
        };

        this.onFinalize = this.onFinalize.bind(this);
        this.getAllStudents = this.getAllStudents.bind(this);
    }

    componentDidMount() {
        axios.all([fetchMarks(), fetchStudyType(), fetchStudyPograms(localStorage.getItem('courseImplementationId'))])
            .then(axios.spread((markRes, studyTypeRes, StudyProgramsRes) => {
                const marks = markRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName),
                    passed: el.passed,
                    key_: el._key,
                    letter: el.letter
                }));

                const studyTypes = studyTypeRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName)
                }));

                const studyPrograms = StudyProgramsRes.data.map(el => ({
                    ...el,
                    key: el.studyProgramId,
                    value: el.studyProgramId,
                    text: el.departments[0].name
                }));

                this.setState({ marks, studyTypes, studyPrograms });
                this.getAllStudents(localStorage.getItem('gradedActivityId'));
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch marks or study types');
            });
    }


    getAllStudents(gradedActivityId) {
        this.setState({ graded: false });
        axios.get(`student-exams/${localStorage.getItem('gradedActivityId')}`)
            .then(res => {
                if (res.data[0].markId !== null) {
                    this.setState({ finishGrading: true });
                }
                this.setState({
                    data: res.data.map(el => ({
                        ...el, markName: el.markId !== null ? this.state.marks.find(e => e.key === el.markId).text : ''
                    })),
                    loaded: true
                });
            })
            .catch(err => {
                console.log('Failed to fetch registered students.');
            });
    }


    onFinalize() {
        axios.put(`professor/finalize-graded-activity/${localStorage.getItem('gradedActivityId')}`)
            .then(res => {
                toast(<FormattedMessage id="professorInputGrades.toastFinalized" />);
            })
            .catch(err => {
                toast(<FormattedMessage id="professorInputGrades.toastFinalizedFailed" />);
            });

        window.history.go(-1);
    }


    render() {
        return (
            <div>
                <Header as="h1"><FormattedMessage id="professorInputGrades.activeCourse" /></Header>

                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            {localStorage.getItem('courseImplementationName')} / {localStorage.getItem('gradedActivityName')} / {localStorage.getItem('date')}
                            <Header.Subheader>
                                <FormattedMessage id="professorStatistics.courseExamDate" />
                            </Header.Subheader>
                        </Header>
                    </Segment>


                    <Segment >
                        {this.state.finalizeCheck ?
                            <div style={{ textAlign: 'center' }}>
                                <h3><FormattedMessage id="professorInputGrades.finalizeCheck" /></h3>
                                <Button.Group >
                                    <Button
                                        basic="true"
                                        color="blue"
                                        onClick={this.onFinalize}
                                    > <FormattedMessage id="common.yes" /></Button>
                                    <Button
                                        basic="true"
                                        color="red"
                                        onClick={() => { this.setState({ finalizeCheck: false }); }}
                                    > <FormattedMessage id="common.no" />

                                    </Button>
                                </Button.Group>
                            </div>
                            : <Button
                                fluid
                                color="red"
                                onClick={() => this.setState({ finalizeCheck: true })}
                            ><h3><b><FormattedMessage id="professorInputGrades.finalize" /></b></h3>
                            </Button>}

                    </Segment>

                    <Segment><h3><FormattedMessage id="common.studentsList" /></h3></Segment>
                    <Segment>
                        {this.state.loaded ? <StudentsWithoutGradesCommitteeExam
                            data={this.state.data}
                            marks={this.state.marks}
                            studyTypes={this.state.studyTypes}
                            studyPrograms={this.state.studyPrograms}
                            getAllStudents={() => this.getAllStudents(localStorage.getItem('gradedActivityId'))}
                            finishGrading={this.state.finishGrading}
                        /> : <Loader active />}
                    </Segment>

                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/GradingCommitteeExam.js